import axios from 'axios'
import { getToken, getRefreshToken } from '@/utils/auth'
import { refreshToken } from '@/api/authorized'
// import router from '../router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000 // request timeout
})

let token = getToken()
let Refreshtoken = getRefreshToken()
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers['Access-Control-Allow-Origin'] = '*'
    // if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // let currentLineAccountId = store.getters.currentLineAccount.id
    // config.headers['SocialAccount'] = currentLineAccountId
    config.headers['Content-Type'] = 'application/json'
    config.headers['Token'] = token
    config.headers['RefreshToken'] = Refreshtoken
    // }

    // config.headers['x-frame-options'] = "ALLOW-FROM SAMEDOMAIN, exacttarget.com"
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
     * If you want to get http information such as headers or status
     * Please return  response => response
  */
  /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
  */
  response => {
    const res = response.data
    const statusCode = response.status
    
    if (statusCode !== 200) {
      return Promise.reject(new Error(res.msg || 'Error'))
    } 
    else {
      return res
    }
    
    async error => {
      console.log('err' + error) // for debug
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshTokenRes = await refreshToken();  
        //axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        //return axiosApiInstance(originalRequest);
      }
    }
  },
  error => {
    if (error.response.status == 401 || error.response.status == 404) {
      // window.location.href = '/loginError';
    }
    return Promise.reject(error)
  }
)

export default service